export default __webpack_public_path__ + "static/media/img5.60027fd0.svg";